var React = require('react');

function Swoop270 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M583.333 292.5L875 292.5C875 131.237 744.413 0.5 583.333 0.5L291.667 0.5L194.444 0.5L169.1 0.5L0 0.5C0 161.507 130.844 292.5 291.667 292.5L437.491 292.5H583.333Z","fill":"currentColor"}));
}

Swoop270.defaultProps = {"width":"875","height":"293","viewBox":"0 0 875 293","fill":"none"};

module.exports = Swoop270;

Swoop270.default = Swoop270;
